export default {
  "pl": {
    "dropzone": {
      "labels": {
        "cancelUpload": "Anuluj przesyłanie",
        "cancelUploadConfirmation": "Czy na pewno chcesz anulować przesyłanie?",
        "chooseCategory": "Kliknij, aby najpierw wybrać kategorię",
        "defaultMessage": "Dodaj lub upuść pliki",
        "fallbackMessage": "Twoja przeglądarka nie umożliwia przesyłania plików metodą „przeciągnij i upuść”.",
        "fallbackText": "Skorzystaj z poniższego formularza bazowego, żeby przesłać pliki jak za dawnych lat.",
        "fileTooBig": "Plik jest zbyt duży ({{filesize}} MB). Maksymalny rozmiar pliku: {{max_filesize}} MB.",
        "invalidFileType": "Nie możesz przesyłać plików tego typu.",
        "maxFilesExceeded": "Nie możesz przesłać większej liczby plików.",
        "removeFile": "Usuń plik",
        "responseError": "Serwer odpowiedział następującym kodem: {{statusCode}}.",
        "uploadConfirmation": "Przesyłanie potwierdzone",
        "warningMaxFileSize": "Do {max_files_size} MB każdy"
      }
    }
  }
}
